export type TransformTool = 'select' | 'move' | 'rotate' | 'scale' | 'pan';

export interface ViewportState {
  zoom: number;
  panX: number;
  panY: number;
  gridSize: number;
  showGrid: boolean;
  showRulers: boolean;
  showGizmos: boolean;
  snapToGrid: boolean;
}

export interface SceneViewSettings {
  canvasWidth: number;
  canvasHeight: number;
  backgroundColor: string;
  defaultZoom: number;
  minZoom: number;
  maxZoom: number;
}

export interface SelectionBounds {
  x: number;
  y: number;
  width: number;
  height: number;
  rotation: number;
}

export interface TransformState {
  isTransforming: boolean;
  startX: number;
  startY: number;
  startValues: {
    position: { x: number; y: number };
    rotation: number;
    scale: { x: number; y: number };
  };
}

export interface BoxSelectionState {
  isSelecting: boolean;
  startX: number;
  startY: number;
  endX: number;
  endY: number;
}

export const DEFAULT_VIEWPORT_STATE: ViewportState = {
  zoom: 1,
  panX: 0,
  panY: 0,
  gridSize: 50,
  showGrid: true,
  showRulers: false,
  showGizmos: true,
  snapToGrid: true,
};

export const DEFAULT_SCENE_VIEW_SETTINGS: SceneViewSettings = {
  canvasWidth: 720,
  canvasHeight: 1560,
  backgroundColor: '#1a1a1a',
  defaultZoom: 1,
  minZoom: 0.1,
  maxZoom: 5,
};

export const ZOOM_PRESETS = [0.25, 0.5, 0.75, 1, 1.5, 2, 3, 4];
